// language=GraphQL
export const ALL_ACCORDION_BLOCKS_QUERY = `query Query($withItems: Boolean = false) {
  accordionBlocks: cmsAccordionBlocks {
    id
    items @include(if: $withItems) {
      id
      title
      content
    }
  }
}`

// language=GraphQL
export const SINGLE_ACCORDION_BLOCK_QUERY = `query Query($id: ID!, $withItems: Boolean = false) {
  accordionBlock: cmsAccordionBlock(id: $id) {
    id
    items @include(if: $withItems) {
      id
      title
      content
    }
  }
}`

// language=GraphQL
export const CREATE_ACCORDION_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsAccordionBlockInput, $withItems: Boolean = false) {
    accordionBlock: createCmsAccordionBlock(input: $input) {
      id
      items @include(if: $withItems) {
        id
        title
        content
      }
    }
  }`

// language=GraphQL
export const UPDATE_ACCORDION_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsAccordionBlockInput, $withItems: Boolean = false) {
    accordionBlock: updateCmsAccordionBlock(input: $input) {
      id
      items @include(if: $withItems) {
        id
        title
        content
      }
    }
  }`

// language=GraphQL
export const DELETE_ACCORDION_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsAccordionBlockInput) {
    deleteCmsAccordionBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCORDION_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsAccordionBlockInput) {
    forceDeleteCmsAccordionBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_ACCORDION_BLOCK_ITEMS_MUTATION = `
  mutation Mutation($input: addCmsAccordionBlockItemsInput) {
    addCmsAccordionBlockItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const REMOVE_ACCORDION_BLOCK_ITEMS_MUTATION = `
  mutation Mutation($input: removeCmsAccordionBlockItemsInput) {
    removeCmsAccordionBlockItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const CREATE_ACCORDION_BLOCK_ITEMS_MUTATION = `
  mutation Mutation($input: createCmsAccordionBlockItemsInput) {
    createCmsAccordionBlockItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const DELETE_ACCORDION_BLOCK_ITEMS_MUTATION = `
  mutation Mutation($input: deleteCmsAccordionBlockItemsInput) {
    deleteCmsAccordionBlockItems(input: $input) {
      id
      itemIds
    }
  }`

// language=GraphQL
export const UPDATE_ACCORDION_BLOCK_ITEMS_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsAccordionBlockItemsOrderInput) {
    updateCmsAccordionBlockItemsOrder(input: $input) {
      id
      itemIds
    }
  }`
